import { render, staticRenderFns } from "./publishers-app.vue?vue&type=template&id=788e66c0"
import script from "./publishers-app.vue?vue&type=script&lang=js"
export * from "./publishers-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports